import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const Icon: FC<ISvG> = ({ fill = "#FFF" }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.6956 4.85674H9.6365V7.31202L14 3.60686L9.6365 0V2.40699H3V9.66327L5.6956 7.68271V4.85674Z"
        fill="#495A64"
      />
      <path
        d="M11.3044 10.9523H7.36331V8.4972L3 12.2024L7.36331 15.8092V13.402H14V5.81592L11.3044 8.12632V10.9523Z"
        fill="#495A64"
      />
    </svg>
  );
};

export default memo(Icon);
